export class SqlQueryExecution {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "sqlEngineId",
            "baseName": "sqlEngineId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "sqlEngineName",
            "baseName": "sqlEngineName",
            "type": "string",
            "format": ""
        },
        {
            "name": "query",
            "baseName": "query",
            "type": "string",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "SqlQueryExecutionStatus",
            "format": ""
        },
        {
            "name": "createdAt",
            "baseName": "createdAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "finishedAt",
            "baseName": "finishedAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "errorMessage",
            "baseName": "errorMessage",
            "type": "string",
            "format": ""
        },
        {
            "name": "createdBy",
            "baseName": "createdBy",
            "type": "string",
            "format": ""
        },
        {
            "name": "resultRowCount",
            "baseName": "resultRowCount",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "bytesScanned",
            "baseName": "bytesScanned",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "filesRead",
            "baseName": "filesRead",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "queuedMs",
            "baseName": "queuedMs",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "planningMs",
            "baseName": "planningMs",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "executionMs",
            "baseName": "executionMs",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "resultFetchMs",
            "baseName": "resultFetchMs",
            "type": "number",
            "format": "int64"
        }
    ];
    static getAttributeTypeMap() {
        return SqlQueryExecution.attributeTypeMap;
    }
    constructor() {
    }
}
